import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import SquircleZoomRegular from './squircle-zoom-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <SquircleZoomRegular {...validProps} />;
}
SvgComponent.iconName = 'squircleZoomRegular';

export const SquircleZoomRegularIcon = svgIconWrapper(SvgComponent);
